'use client';

import type { HITLRequestConfirmationMessage } from '@terra/shared-dto-chat-types';
import { useBackgroundExecution } from '../../BackgroundExecutionContext';

export function useHitlDecisionWindow({
  dataMessage,
  isLastMessage,
}: {
  dataMessage?: HITLRequestConfirmationMessage;
  isLastMessage?: boolean;
}) {
  const getBackgroundExecutionByToolCallId =
    useBackgroundExecution()?.getBackgroundExecutionByToolCallId;
  const backgroundToolCallId = dataMessage?.backgroundSubagent?.toolCallId;
  const hasBackgroundStore = !!getBackgroundExecutionByToolCallId;
  const backgroundExecution = backgroundToolCallId
    ? getBackgroundExecutionByToolCallId?.(backgroundToolCallId)
    : undefined;
  const isBackgroundChildAwaitingDecision =
    !!backgroundToolCallId &&
    hasBackgroundStore &&
    (!backgroundExecution ||
      (!backgroundExecution.isRunning && !backgroundExecution.terminalStatus));

  return {
    getBackgroundExecutionByToolCallId,
    canDecide: !!isLastMessage || isBackgroundChildAwaitingDecision,
  };
}
